import React from "react";
import { useNavigate } from "react-router-dom";

function AdminDashboard() {

  const navigate = useNavigate();

  // ✅ LOGOUT
  const handleLogout = () => {
    navigate("/");
  };

  return (

    <div style={{ backgroundColor: "#F6F5F2", minHeight: "100vh" }}>

      {/* HEADER */}
      <div className="container py-3 d-flex justify-content-between align-items-center">

        <h3 style={{ color: "#9b2226", fontWeight: "600" }}>
          Admin Dashboard
        </h3>

        <button
          onClick={handleLogout}
          className="btn"
          style={{
            backgroundColor: "rgb(123, 74, 28)",
            color: "white",
            borderRadius: "8px"
          }}
        >
          Logout
        </button>

      </div>

      <div className="container mt-4">

        <div className="row">

          {/* APPOINTMENTS */}
          <div className="col-md-4 mb-3">
            <div
              className="p-4 shadow-sm text-center"
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                borderTop: "4px solid #9b2226"
              }}
            >
              <h5>Appointments</h5>
              <button
                className="btn mt-2"
                style={{ backgroundColor: "#9b2226", color: "white" }}
                onClick={() => navigate("/admin-appointments")}
              >
                Manage
              </button>
            </div>
          </div>

          {/* PRODUCTS */}
          <div className="col-md-4 mb-3">
            <div
              className="p-4 shadow-sm text-center"
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                borderTop: "4px solid rgb(123, 74, 28)"
              }}
            >
              <h5>Products</h5>
              <button
                className="btn mt-2"
                style={{ backgroundColor: "#9b2226", color: "white" }}
                onClick={() => navigate("/products")}
              >
                Manage
              </button>
            </div>
          </div>

          {/* QUERIES */}
          <div className="col-md-4 mb-3">
            <div
              className="p-4 shadow-sm text-center"
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                borderTop: "4px solid #9b2226"
              }}
            >
              <h5>Website Queries</h5>
              <button
                className="btn mt-2"
                style={{ backgroundColor: "#9b2226", color: "white" }}
                onClick={() => navigate("/queries")}
              >
                View
              </button>
            </div>
          </div>

          {/* ADD DOCTOR */}
          <div className="col-md-4 mb-3">
            <div
              className="p-4 shadow-sm text-center"
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                borderTop: "4px solid rgb(123, 74, 28)"
              }}
            >
              <h5>Add Doctor</h5>
              <button
                className="btn mt-2"
                style={{ backgroundColor: "#9b2226", color: "white" }}
                onClick={() => navigate("/add-doctor")}
              >
                Add
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default AdminDashboard;